if (!String.prototype.toCapitalize) {
  String.prototype.toCapitalize = function () {
    return this[0].toUpperCase() + this.substring(1);
  };
}


